const DpoPrilohyVyuctovani = {
    init: function () {
        const sekceId = $("#idSection").val();

        if (!sekceId || sekceId !== '101') {
            return;
        }

        const element = $("#povinneprilohyvyuctovani-3");
        if (!element.length) {
            return;
        }

        element.attr("disabled", true).prop("disabled", true);
    }
}


$(document).ready(function () {
    DpoPrilohyVyuctovani.init();
});
